<template>
    <div @click="closeBoxModal" class="box-modal-container" >
        <div v-on:click.stop class="page4-container">
            <div id="header-container" class="page4-header">
                <p class="main-title">Gift Box Design</p>
                <p class="main-subtitle">Please pick a box design! Our boxes will <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"> automagically <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_5257b419-6ffa-4278-bd91-46864bc15443.svg?v=1656613004"> change sizes to ensure the perfect fit!</p>
            </div>
            <ul v-if="bestBoxes.length > 0" class="boxes-container">
                <li v-for="box in bestBoxes" :key="box.id">
                    <div class="box-container">
                        <div class="main-image-container" :class="selectedBox.id == box.id ? 'selected' : '' ">
                            <img v-if="selectedBox.id == box.id " class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                            <img @click="selectBox(box)" class="main-image lazyload" :data-src="box | getProductImage">
                        </div>
                        <p class="box-title">{{box.title}}</p>
                        <p class="box-desc">{{box | moneyFormat}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
        }
    },
    props:{
        boxQty: Number
    },
    computed: {
        ...mapGetters([
            'mainProducts',
            'selectedBox',
            'currentCapacity',
            'selectedAddonProducts',
        ]),
        bestBoxes(){
            //Get if it has a fragile product. If so, only show big boxes
            var fragile = this.selectedAddonProducts.some(x => x.tags.includes("XLTRIGGER"));

            let separatedBoxes = this.mainProducts.filter((x) => {
                let tags = x.tags.split(",");
                if(tags.some(y => y.includes("QTYMIN"))){
                    let minTag = tags.find(x => x.includes("QTYMIN"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];

                        return this.boxQty >= minTag;
                    }

                    return false
                }

                return true
            })

            
            //Get all boxes variants
            separatedBoxes = separatedBoxes.flatMap((box) => {
                var boxes = box.variants.map((variant) =>{
                    var currentBoxes = JSON.parse(JSON.stringify(box));;
                    currentBoxes.variants = [variant];

                    return currentBoxes;
                })

                return boxes;
            })

            separatedBoxes = separatedBoxes.filter(x => x.variants[0].inventory_quantity >= this.boxQty);
            let sizes = separatedBoxes.map(x => x.variants[0].title);
            let uSizes = [...new Set(sizes)];
            let boxSize = null;
            uSizes.sort();
            if(fragile){
                let minBox = Math.min(...uSizes);
                boxSize = Math.min(...uSizes.filter(x => x >= this.currentCapacity && x != minBox)); 
            }
            else {
                boxSize = Math.min(...uSizes.filter(x => x >= this.currentCapacity)); 
            }
            separatedBoxes = separatedBoxes.filter(x => x.variants[0].title == boxSize);

            return separatedBoxes;
        }
    },
    methods: {
        selectBox(box){
            this.$store.commit('setSelectedBox', box);
            this.$emit("addcart", true);
        },
        closeBoxModal(){
            this.$emit("close", true);
        },
        isMobile() {
            return window.innerWidth < 768;
        },
    },

}
</script>

<style scoped>

.page4-container{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    overflow-y: scroll;
    border-radius: 20px;
}
.main-title{
    color: #0F0C38;
    font-family: 'moret',sans-serif !important;
    font-size: 2.5vw;
    margin-top: 2%;
    letter-spacing: 0.03em;
}

.main-subtitle img{
    width: 1.5%;
    margin: 0% 0.2%;
}

.main-subtitle{
    font-size: 1.2vw;
    color: #3f3d60;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.boxes-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    margin: unset;
    padding: 3% 10% 0%;
}

.boxes-container li{
    width: 23%;
    margin-right: 2%;
    margin-bottom: 5%;
}

.box-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-image-container{
    width: 100%;
    border-radius: 4px;
    position: relative;
    background: url(https://cdn.shopify.com/s/files/1/1363/8433/files/boxbg.png?v=1659549291) no-repeat;
    background-size: contain;
}

.main-image-container.selected{
    border: 1px solid #16A34A;
}

.green-check{
    position: absolute;
    top: 0;
    left: 0;
}
.main-image{
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
}

.main-image:hover{
    animation: MoveUpDown 2.5s ease-in-out infinite;
}

.box-title{
    font-size: 1.1vw;
    font-weight: bold;
    padding-top: 5%;
}

.box-desc{
    color: #A186C4 !important;
    font-size: 1vw;
    line-height: 1.4;
    padding-bottom: 5%;
}

.iframe-container{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.close-iframe{
    font-size: 2vw;
    cursor: pointer;
    position: absolute;
    top: 10%;
    right: 20%;
}

.page4-header{
    text-align: center;
}

    .box-modal-container{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 43;
        padding: 5% 10%;
    }

@media screen and (min-width: 768px) {

    .box-modal-container{
        padding: 5%;
    }
    .page4-header{
        position: sticky;
        top: 0vh;
        width: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        background-color: white;
        z-index: 1;
    }

    .page4-header.sticking{
        box-shadow: 0px 2px 1px 0px #0003;
        padding: 1% 0%;
    }

    .sticking .main-title{
        font-size: 2vw;
        margin-top: unset;
    }
}

@media screen and (max-width: 767px){
    .main-title{
        font-size: 5vw;
    }
    .main-subtitle{
        font-size: 3vw;
        text-align: center;
    }

    .main-subtitle img {
        width: 4%;
        margin: 0% 1%;
    }

    .boxes-container li{
        width: 48%;
        padding-bottom: 5%;
    }

    .box-desc{
        font-size: 3vw;
    }

    .box-title{
        font-size: 3.5vw;
    }

    .iframe-container{
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .close-iframe{
        font-size: 8vw;
        cursor: pointer;
        position: absolute;
        top: 0%;
        right: 5%;
    }
}
</style>